import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <span className="inline-block px-3 py-1 text-xs font-semibold bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap mb-4">
              创作者入口
            </span>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              {contactData.title}
            </h2>
            <p className="mt-2 text-lg text-foreground-600">
              {contactData.subtitle}
            </p>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              {contactData.desc}
            </p>

            <div className="mt-8 p-6 bg-background-50 rounded-2xl border border-background-200/70">
              <div className="flex items-center justify-center gap-3">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <div className="text-left">
                  <span className="block text-xs text-foreground-500">官方邮箱</span>
                  <span className="text-base font-semibold text-foreground-900 whitespace-nowrap">
                    {contactData.email}
                  </span>
                </div>
              </div>
              <p className="mt-5 text-xs text-foreground-400">
                我们会在3-5个工作日内回复您的来信
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}